import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgIf} from "@angular/common";
import {take} from "rxjs";
import {ExternService} from "../../services/extern.service";
import {NewsletterSubscription} from "../../models/model";

@Component({
    selector: 'app-subscribe',
    standalone: true,
    templateUrl: './subscribe.component.html',
    imports: [
        ReactiveFormsModule,
        NgIf
    ],
    styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent {
    newsletterForm: FormGroup;
    subscriptionSuccess: boolean = false;

    constructor(private fb: FormBuilder, private externService: ExternService) {
        this.newsletterForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    onSubmit(): void {
        if (this.newsletterForm.valid) {
            const subscriptionData: NewsletterSubscription = this.newsletterForm.value;

            console.log('Newsletter Subscription:', subscriptionData);
            this.externService.subscribeNewsletter(subscriptionData).pipe(take(1)).subscribe({
                next: ()=>{
                    this.subscriptionSuccess = true;
                    this.newsletterForm.reset();
                }
            })

        } else {
            this.newsletterForm.markAllAsTouched();
        }
    }

}
